import { render, staticRenderFns } from "./SkillSearchWeaponSelector.vue?vue&type=template&id=3785c56d&scoped=true&"
import script from "./SkillSearchWeaponSelector.vue?vue&type=script&lang=ts&"
export * from "./SkillSearchWeaponSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSearchWeaponSelector.vue?vue&type=style&index=0&id=3785c56d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785c56d",
  null
  
)

export default component.exports